import React from 'react';

import Routes from './routes';
import {
  SheetContext,
  sheetData,
  AppGlobalProps,
  AppContext,
} from './context/SheetContext';
import GlobalStyle from './styles/global';

type AppProps = {
  sheets: sheetData[];
  appProps: AppGlobalProps;
};

const App: React.FC<AppProps> = ({ sheets, appProps }: AppProps) => {
  return (
    <SheetContext.Provider value={sheets}>
      <AppContext.Provider value={appProps}>
        <Routes sheetId={sheets[0].id} />
        <GlobalStyle />
      </AppContext.Provider>
    </SheetContext.Provider>
  );
};

export default App;
